<template>
  <div v-if="currentStep.handle != 'star-wars-bracelet-light-or-dark-side'">
    <div
      v-for="bracelet in mapModBraceletsMeta"
      :key="bracelet.id"
      class="c-infusion-message"
    >
      <div v-if="bracelet.handle === selections.bracelet.handle">
        <p
          v-if="bracelet.metafieldsMap.color && bracelet.metafieldsMap.color.value && bracelet.metafieldsMap.color.value.infused[0]"
          class="t-heading-8"
        >
          BAND INFUSED WITH REAL {{ bracelet.metafieldsMap.color && bracelet.metafieldsMap.color.value && bracelet.metafieldsMap.color.value.infused[0] }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapProducts } from "@/utils/shopifyHelper";

export default {
  name: "InfusionMessage",
  computed: {
    ...mapState('braceletBuilder',[
      'bracelets',
      'selections',
      'currentStep',
    ]),
    mapModBraceletsMeta() {
      return mapProducts(this.bracelets);
    },
  }
}
</script>

<style scoped lang="scss">
    .c-infusion-message{
        display: block;
        width: 100%;
        position: absolute;
        bottom: rem(20px);
        text-align:center;
    }
</style>
